/*global __CLIENT__*/
import React, { Component } from 'react';

export default class LoadingMotion extends Component {
  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     position: 'translate(0, 0)',
  //   }
  // }

  // componentDidMount = () => {
  //   this.setState({
  //     position: setInterval(this.updatePosition, 3000)
  //   })
  // }

  // componentWillUnmount = () => {
  //   clearInterval(this.state.position)
  // }

  // updatePosition = () => {
  //   const { position } = this.state;

  //   if (position === 'translate(0, 0)' || position === 'translate(-350px, 0)') {
  //     this.setState({
  //       position: 'translate(350px, 0)',
  //     })
  //   } else {
  //     this.setState({
  //       position: 'translate(-350px, 0)',
  //     })
  //   }
  // }

  render() {
    const { loadingMessage } = this.props;
    // const { position } = this.state;

    const wrapperStyle = {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flex: '1 0 100%',
      flexDirection: 'column',
    };

    return (
      <div style={wrapperStyle}>
        <div id="axis" className="four">
          {/* <i
            style={{
              transform: position,
              transition: 'all 2s ease-in-out',
            }}
            className="object coin move-down fa fa-user-md fa-5x"
          /> */}
          <i
            className="object coin move-down fa fa-user-md fa-5x"
          />
        </div>
        <div>
          <b>{loadingMessage}</b>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingMotion.js